import { Dispatch, SetStateAction } from 'react'

import { clsx } from 'clsx'

import { ColorScheme } from '@tribeplatform/design-system/types'
import { useI18n } from '@tribeplatform/react-components/i18n'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { RadioGroup } from '@tribeplatform/react-ui-kit/RadioGroup'

import { getTranslatedColorScheme } from '../utils.js'

export const ColorSchemeRadioItem = ({
  colorScheme,
  onSelect,
  active,
}: {
  colorScheme: ColorScheme
  onSelect: Dispatch<SetStateAction<ColorScheme>>
  active: boolean
}) => {
  const { $t } = useI18n()

  return (
    <RadioGroup.Item value={colorScheme} className="group">
      <div className="w-full flex gap-2 items-center justify-between">
        <div>{getTranslatedColorScheme($t, colorScheme)}</div>
        <IconButton
          icon={<SvgIcon name="edit" />}
          variant="secondaryNeutral"
          rounded
          size="sm"
          onClick={() => onSelect(colorScheme)}
          className={clsx(
            'opacity-0 group-hover:opacity-100 transition-opacity',
            active && 'opacity-100',
          )}
        />
      </div>
    </RadioGroup.Item>
  )
}
